module.exports = __webpack_public_path__ + "img/Download-grey.acc32f44.png";